import { MAGNETIC_TOKENS, ToggleSwitch } from '@appd/uik';

interface DashifyDescriptionProps {
  description: string | undefined;
  showDescription: boolean;
  updateDescription: (value: string) => void;
  updateDescriptionState: (state: boolean) => void;
}

const {
  COLORS: { CONTROL_BORDER },
} = MAGNETIC_TOKENS;
export const DashifyDescription: React.FC<DashifyDescriptionProps> = ({
  description,
  showDescription,
  updateDescription,
  updateDescriptionState,
}) => {
  return (
    <div className="py-1 flex items-center gap-2 w-full">
      <input
        data-testid="dashify-edit-mode-description"
        className="px-2 py-1 border-2 rounded-md w-[50%] truncate"
        style={{ borderColor: CONTROL_BORDER }}
        onChange={e => updateDescription(e.target.value)}
        placeholder={'Enter description'}
        value={description}
      />
      <ToggleSwitch on={showDescription} onSwitch={toggleState => updateDescriptionState(toggleState)} />
      <div className="ml-[40px]">Show in view mode</div>
    </div>
  );
};
